import { Injectable } from '@angular/core';
import { ApiUrlProvider } from './api-url.provider';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IApiResult } from '../shared/models/api-result';
import { Role } from '../shared/models/role';
import { User } from '../shared/models/user';
import { ProjectColumnAccessModel } from '../shared/models/project-column-access-model';
import { Operation } from '../shared/models/operation';
import { UserContext } from '../shared/models/user-context';

@Injectable({
  providedIn: 'root'
})
export class UserRoleService {
  constructor(
    private http: HttpClient,
    private apiUrlProvider: ApiUrlProvider) { }

  getUserContext(): Observable<IApiResult<UserContext>>{
    return this.http.get<IApiResult<UserContext>>(`${this.apiUrlProvider.url}/UserContext`);
  }
  
  getUsers(): Observable<IApiResult<User[]>>{
    return this.http.get<IApiResult<User[]>>(`${this.apiUrlProvider.url}/Users`);
  }

  getRoles(): Observable<IApiResult<Role[]>>{
    return this.http.get<IApiResult<Role[]>>(`${this.apiUrlProvider.url}/Roles`);
  }

  getRolesByUser(userId: string): Observable<IApiResult<Role[]>>{
    return this.http.get<IApiResult<Role[]>>(`${this.apiUrlProvider.url}/Users/${userId}/Roles`);
  }

  isUserAdmin(): Observable<IApiResult<boolean>>{
    return this.http.get<IApiResult<boolean>>(`${this.apiUrlProvider.url}/Users/IsAdmin`);
  }

  getUsersByRole(roleId: number): Observable<IApiResult<User[]>>{
    return this.http.get<IApiResult<User[]>>(`${this.apiUrlProvider.url}/Roles/${roleId}/Users`);
  }

  addRole(role: Role): Observable<IApiResult<Role>>{
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json'
      })
    };

    return this.http.post<IApiResult<Role>>(`${this.apiUrlProvider.url}/Roles`, role, httpOptions);
  }

  updateRole(role: Role): Observable<IApiResult<Role>>{
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json'
      })
    };

    return this.http.post<IApiResult<Role>>(`${this.apiUrlProvider.url}/Roles/${role.id}/Update`, role, httpOptions);
  }

  addUserToRole(roleId: number, user:User): Observable<IApiResult<User[]>>{
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json'
      })
    };

    return this.http.post<IApiResult<User[]>>(`${this.apiUrlProvider.url}/Roles/${roleId}/Users`, user, httpOptions);
  }

  deleteUserFromRole(roleId: number, userId: number): Observable<IApiResult<User[]>>{
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json'
      })
    };

    return this.http.post<IApiResult<User[]>>(`${this.apiUrlProvider.url}/Roles/${roleId}/Users/${userId}/Delete`, null, httpOptions);
  }

  getProjectColumnsAccessModelByRole(roleId: number): Observable<IApiResult<ProjectColumnAccessModel[]>>{
    return this.http.get<IApiResult<ProjectColumnAccessModel[]>>(`${this.apiUrlProvider.url}/Project/RoleColumnAccessSetting/${roleId}`);
  }

  updateProjectColumnAccessSetting(roleId: number, projectColumnAccessSetting: ProjectColumnAccessModel)
    : Observable<IApiResult<ProjectColumnAccessModel[]>>{
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json'
      })
    };

    return this.http.post<IApiResult<ProjectColumnAccessModel[]>>(`${this.apiUrlProvider.url}/Project/RoleColumnAccessSetting/${roleId}`, [projectColumnAccessSetting], httpOptions);
  }

  getOperationsByUser(userId: string): Observable<IApiResult<Operation[]>>{
    return this.http.get<IApiResult<Operation[]>>(`${this.apiUrlProvider.url}/Users/${userId}/Operations`);
  }
}
